import { allowOnlyEnKrCharacter, NOOP, showAlert } from '@/utils';
import { useCallback, useState } from 'react';

import { isNilOrEmpty } from 'ramda-adjunct';

import { TDownloadPersonalInfoProps } from './download-personal-info.type';

export const useLogic = ({
	onDownload,
	onCancel,
}: TDownloadPersonalInfoProps) => {
	const [reason, setReason] = useState('');
	const [loading, setLoading] = useState(false);

	const handleClick = useCallback(() => {
		if (isNilOrEmpty(reason)) {
			showAlert('다운로드 사유를 입력해주세요.', NOOP);
			return;
		}

		setLoading(true);

		onDownload?.(reason, () => {
			setReason('');
			onCancel?.();
			setLoading(false);
		});
	}, [reason, onDownload, onCancel]);

	const handleInputChange = useCallback(
		(e: React.ChangeEvent<HTMLInputElement>) => {
			const value = allowOnlyEnKrCharacter(e.target.value);
			setReason(value);
		},
		[]
	);

	return {
		reason,
		loading,
		setReason,
		handleClick,
		handleInputChange,
	};
};
